import React, { forwardRef } from 'react'
import { useField } from './Field'

function cx (...classes) {
  return classes.filter(Boolean).join(' ')
}

/**
 * Input — plain <input> wrapper with shadcn-style styling hooks.
 *
 * If rendered inside a <Field>, it automatically:
 *   - gets the Field's generated `id` (unless you pass your own)
 *   - gets `aria-describedby` pointed at the Field's description
 *   - reflects the Field's `invalid`/`disabled` state via data-* + aria-*
 *
 * Otherwise it behaves like a normal controlled/uncontrolled <input>.
 */
export const Input = forwardRef(function Input (
  { className, type = 'text', id, disabled, 'aria-invalid': ariaInvalidProp, ...props },
  ref
) {
  const field = useField()

  const resolvedId = id ?? field.id
  const invalid = ariaInvalidProp ?? field.invalid
  const isDisabled = disabled ?? field.disabled

  return (
    <input
      ref={ref}
      type={type}
      id={resolvedId}
      data-slot='input'
      aria-invalid={invalid || undefined}
      aria-describedby={field.descriptionId}
      disabled={isDisabled}
      className={cx('input glass', className)}
      {...props}
    />
  )
})

export default Input
